/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PreviewStepRenderStatus } from './previewStepRenderStatus';

/**
 * Frozen rendered content + render state for one candidate × step cell.
 *
 * The preview UI reads this per (candidate, step) to show the
 * "generating… / done" state and the pre-computed content. Only the
 * channel relevant to the step type is populated; the rest stay
 * ``None``. Mirrors
 * :class:`app.services.outreach.preview_render.RenderedPreviewCell`
 * (the shape the P2-4b render job produces).
 */
export interface PreviewStepRender {
  step_id: string;
  status?: PreviewStepRenderStatus;
  email_subject?: string | null;
  email_body_html?: string | null;
  email_body_text?: string | null;
  linkedin_message_text?: string | null;
  task_note_text?: string | null;
  error?: string | null;
}
